export const lineEmoji = {
  emojiSet: [
    {
      name: 'moon heart eyes',
      position: '-4px 0px',
      id: '001'
    },
    {
      name: 'moon laugh',
      position: '-89px 0px',
      id: '002'
    },
    {
      name: 'moon pleading',
      position: '-174px 0px',
      id: '003'
    },
    {
      name: 'moon shocked',
      position: '-259px 0px',
      id: '004'
    },
    {
      name: 'moon cry',
      position: '-344px 0px',
      id: '005'
    },
    {
      name: 'moon gaunt',
      position: '-429px 0px',
      id: '006'
    },
    {
      name: 'moon furious',
      position: '-514px 0px',
      id: '007'
    },
    {
      name: 'moon smirk',
      position: '-599px 0px',
      id: '008'
    },
    {
      name: 'moon big smile',
      position: '-684px 0px',
      id: '009'
    },
    {
      name: 'moon oops',
      position: '-769px 0px',
      id: '010'
    },
    {
      name: 'moon wink',
      position: '-854px 0px',
      id: '011'
    },
    {
      name: 'moon smile',
      position: '-939px 0px',
      id: '012'
    },
    {
      name: 'moon sweat',
      position: '-4px -88px',
      id: '013'
    },
    {
      name: 'moon depressed',
      position: '-89px -88px',
      id: '014'
    },
    {
      name: 'moon eating',
      position: '-174px -88px',
      id: '015'
    },
    {
      name: 'moon angry',
      position: '-259px -88px',
      id: '016'
    },
    {
      name: 'moon annoyed',
      position: '-344px -88px',
      id: '017'
    },
    {
      name: 'moon laugh',
      position: '-429px -88px',
      id: '018'
    },
    {
      name: 'moon streaming tears',
      position: '-514px -88px',
      id: '019'
    },
    {
      name: 'moon excited',
      position: '-599px -88px',
      id: '020'
    },
    {
      name: 'moon sunglasses',
      position: '-684px -88px',
      id: '021'
    },
    {
      name: 'moon amused',
      position: '-769px -88px',
      id: '022'
    },
    {
      name: 'moon sigh',
      position: '-854px -88px',
      id: '023'
    },
    {
      name: 'moon troubled',
      position: '-939px -88px',
      id: '024'
    },
    {
      name: 'moon halo',
      position: '-4px -172px',
      id: '025'
    },
    {
      name: 'moon sick',
      position: '-89px -172px',
      id: '026'
    },
    {
      name: 'moon with tongue out',
      position: '-174px -172px',
      id: '027'
    },
    {
      name: 'moon unwell',
      position: '-259px -172px',
      id: '028'
    },
    {
      name: 'moon big eyes',
      position: '-344px -172px',
      id: '029'
    },
    {
      name: 'moon kiss',
      position: '-429px -172px',
      id: '030'
    },
    {
      name: 'moon sleep',
      position: '-514px -172px',
      id: '031'
    },
    {
      name: 'moon smirk',
      position: '-599px -172px',
      id: '032'
    },
    {
      name: 'moon sad',
      position: '-684px -172px',
      id: '033'
    },
    {
      name: 'moon apology',
      position: '-769px -172px',
      id: '034'
    },
    {
      name: 'moon cute smile',
      position: '-854px -172px',
      id: '035'
    },
    {
      name: 'moon stone face',
      position: '-939px -172px',
      id: '036'
    },
    {
      name: 'moon heart eyes',
      position: '-4px -257px',
      id: '037'
    },
    {
      name: 'cony laugh',
      position: '-89px -257px',
      id: '038'
    },
    {
      name: 'cony sparkling eyes',
      position: '-174px -257px',
      id: '039'
    },
    {
      name: 'cony kiss',
      position: '-259px -257px',
      id: '040'
    },
    {
      name: 'cony with tongue out',
      position: '-344px -257px',
      id: '041'
    },
    {
      name: 'cony shocked',
      position: '-429px -257px',
      id: '042'
    },
    {
      name: 'cony smile',
      position: '-514px -257px',
      id: '043'
    },
    {
      name: 'cony big smile',
      position: '-599px -257px',
      id: '044'
    },
    {
      name: 'cony kiss',
      position: '-684px -257px',
      id: '045'
    },
    {
      name: 'cony cry',
      position: '-769px -257px',
      id: '046'
    },
    {
      name: 'cony kiss',
      position: '-854px -257px',
      id: '047'
    },
    {
      name: 'cony grin',
      position: '-939px -257px',
      id: '048'
    },
    {
      name: 'cony freezing',
      position: '-4px -343px',
      id: '049'
    },
    {
      name: 'cony exhausted',
      position: '-89px -343px',
      id: '050'
    },
    {
      name: 'cony angry',
      position: '-174px -343px',
      id: '051'
    },
    {
      name: 'cony sweat',
      position: '-259px -343px',
      id: '052'
    },
    {
      name: 'cony sleeping',
      position: '-344px -343px',
      id: '053'
    },
    {
      name: 'cony cute smile',
      position: '-429px -343px',
      id: '054'
    },
    {
      name: 'cony furious',
      position: '-514px -343px',
      id: '055'
    },
    {
      name: 'cony heart eyes',
      position: '-599px -343px',
      id: '056'
    },
    {
      name: 'cony mad',
      position: '-684px -343px',
      id: '057'
    },
    {
      name: 'cony distressed',
      position: '-769px -343px',
      id: '058'
    },
    {
      name: 'Cony interested',
      position: '-854px -343px',
      id: '059'
    },
    {
      name: 'cony annoyed',
      position: '-939px -343px',
      id: '060'
    },
    {
      name: 'Cony streaming tears',
      position: '-4px -428px',
      id: '061'
    },
    {
      name: 'cony sad',
      position: '-89px -428px',
      id: '062'
    },
    {
      name: 'cony shocked',
      position: '-174px -428px',
      id: '063'
    },
    {
      name: 'cony wink',
      position: '-259px -428px',
      id: '064'
    },
    {
      name: 'leonard crossed-out eyes',
      position: '-344px -428px',
      id: '065'
    },
    {
      name: 'leonard smile',
      position: '-429px -428px',
      id: '066'
    },
    {
      name: 'leonard wide eyes',
      position: '-514px -428px',
      id: '067'
    },
    {
      name: 'leonard laugh',
      position: '-599px -428px',
      id: '068'
    },
    {
      name: 'leonard closed eyes',
      position: '-684px -428px',
      id: '069'
    },
    {
      name: 'leonard tears',
      position: '-769px -428px',
      id: '070'
    },
    {
      name: 'leonard big eyes',
      position: '-854px -428px',
      id: '071'
    },
    {
      name: 'leonard shocked',
      position: '-939px -428px',
      id: '072'
    },
    {
      name: 'leonard smile',
      position: '-4px -513px',
      id: '073'
    },
    {
      name: 'leonard kiss',
      position: '-89px -513px',
      id: '074'
    },
    {
      name: 'leonard angry',
      position: '-174px -513px',
      id: '075'
    },
    {
      name: 'sally',
      position: '-259px -513px',
      id: '076'
    },
    {
      name: 'sally smile',
      position: '-344px -513px',
      id: '077'
    },
    {
      name: 'sally furious',
      position: '-429px -513px',
      id: '078'
    },
    {
      name: 'Sally sweat',
      position: '-514px -513px',
      id: '079'
    },
    {
      name: 'Sally surprised',
      position: '-599px -513px',
      id: '080'
    },
    {
      name: 'sally angry',
      position: '-684px -513px',
      id: '081'
    },
    {
      name: 'sally sunglasses',
      position: '-769px -513px',
      id: '082'
    },
    {
      name: 'sally tears',
      position: '-854px -513px',
      id: '083'
    },
    {
      name: 'sally sleep',
      position: '-939px -513px',
      id: '084'
    },
    {
      name: 'sally heart eyes',
      position: '-4px -598px',
      id: '085'
    },
    {
      name: 'Brown',
      position: '-89px -598px',
      id: '086'
    },
    {
      name: 'Brown sweat',
      position: '-174px -598px',
      id: '087'
    },
    {
      name: 'brown blush',
      position: '-259px -598px',
      id: '088'
    },
    {
      name: 'brown surprised',
      position: '-344px -598px',
      id: '089'
    },
    {
      name: 'brown sleeping',
      position: '-429px -598px',
      id: '090'
    },
    {
      name: 'brown sunglasses',
      position: '-514px -598px',
      id: '091'
    },
    {
      name: 'brown tears',
      position: '-599px -598px',
      id: '092'
    },
    {
      name: 'brown kiss marks',
      position: '-684px -598px',
      id: '093'
    },
    {
      name: 'brown heart eyes',
      position: '-769px -598px',
      id: '094'
    },
    {
      name: 'james sweat',
      position: '-854px -598px',
      id: '095'
    },
    {
      name: 'james exhausted',
      position: '-939px -598px',
      id: '096'
    },
    {
      name: 'james panicking',
      position: '-4px -683px',
      id: '097'
    },
    {
      name: 'james wink heart',
      position: '-89px -683px',
      id: '098'
    },
    {
      name: 'james heart eyes',
      position: '-174px -683px',
      id: '099'
    },
    {
      name: 'james thinking',
      position: '-259px -683px',
      id: '100'
    },
    {
      name: 'james serious',
      position: '-344px -683px',
      id: '101'
    },
    {
      name: 'smile',
      position: '-429px -683px',
      id: '102'
    },
    {
      name: 'laugh',
      position: '-514px -683px',
      id: '103'
    },
    {
      name: 'big smile',
      position: '-599px -683px',
      id: '104'
    },
    {
      name: 'happy face',
      position: '-684px -683px',
      id: '105'
    },
    {
      name: 'big grin',
      position: '-769px -683px',
      id: '106'
    },
    {
      name: 'laugh',
      position: '-854px -683px',
      id: '107'
    },
    {
      name: 'pleased face',
      position: '-939px -683px',
      id: '108'
    },
    {
      name: 'mischevious grin',
      position: '-4px -768px',
      id: '109'
    },
    {
      name: 'tears of laughter',
      position: '-89px -768px',
      id: '110'
    },
    {
      name: 'wink',
      position: '-174px -768px',
      id: '111'
    },
    {
      name: 'kind smile',
      position: '-259px -768px',
      id: '112'
    },
    {
      name: 'kiss',
      position: '-344px -768px',
      id: '113'
    },
    {
      name: 'heart eyes',
      position: '-429px -768px',
      id: '114'
    },
    {
      name: 'smile with heart eyes',
      position: '-514px -768px',
      id: '115'
    },
    {
      name: 'smile',
      position: '-599px -768px',
      id: '116'
    },
    {
      name: 'face with flower',
      position: '-684px -768px',
      id: '117'
    },
    {
      name: 'face with sunglasses',
      position: '-769px -768px',
      id: '118'
    },
    {
      name: 'wink',
      position: '-854px -768px',
      id: '119'
    },
    {
      name: 'forced smile',
      position: '-939px -768px',
      id: '120'
    },
    {
      name: 'sweating smiley face',
      position: '-4px -853px',
      id: '121'
    },
    {
      name: 'bashful grin',
      position: '-89px -853px',
      id: '122'
    },
    {
      name: 'angry',
      position: '-174px -853px',
      id: '123'
    },
    {
      name: 'tears of laughter',
      position: '-259px -853px',
      id: '124'
    },
    {
      name: 'face with full cheeks',
      position: '-344px -853px',
      id: '125'
    },
    {
      name: 'frown',
      position: '-429px -853px',
      id: '126'
    },
    {
      name: 'surprise',
      position: '-514px -853px',
      id: '127'
    },
    {
      name: 'sad face',
      position: '-599px -853px',
      id: '128'
    },
    {
      name: 'unpleasant face',
      position: '-684px -853px',
      id: '129'
    },
    {
      name: 'sick',
      position: '-769px -853px',
      id: '130'
    },
    {
      name: 'crossed-out eyes)',
      position: '-854px -853px',
      id: '131'
    },
    {
      name: 'crossed-out eyes',
      position: '-939px -853px',
      id: '132'
    },
    {
      name: 'tears',
      position: '-4px -938px',
      id: '133'
    },
    {
      name: 'bawl',
      position: '-89px -938px',
      id: '134'
    },
    {
      name: 'angry',
      position: '-174px -938px',
      id: '135'
    },
    {
      name: 'angry',
      position: '-259px -938px',
      id: '136'
    },
    {
      name: 'stone face',
      position: '-344px -938px',
      id: '137'
    },
    {
      name: 'shocked face',
      position: '-429px -938px',
      id: '138'
    },
    {
      name: 'shocked face',
      position: '-514px -938px',
      id: '139'
    },
    {
      name: 'sly smirk',
      position: '-599px -938px',
      id: '140'
    },
    {
      name: 'resentful face',
      position: '-684px -938px',
      id: '141'
    },
    {
      name: 'wide-eyed face',
      position: '-769px -938px',
      id: '142'
    },
    {
      name: 'drooling',
      position: '-854px -938px',
      id: '143'
    },
    {
      name: 'side glance',
      position: '-939px -938px',
      id: '144'
    },
    {
      name: 'looking away',
      position: '-4px -1023px',
      id: '145'
    },
    {
      name: 'mustache and glasses',
      position: '-89px -1023px',
      id: '146'
    },
    {
      name: 'pouting',
      position: '-174px -1023px',
      id: '147'
    },
    {
      name: 'sleep',
      position: '-259px -1023px',
      id: '148'
    },
    {
      name: 'avoiding gaze',
      position: '-344px -1023px',
      id: '149'
    },
    {
      name: 'crazy blue face',
      position: '-429px -1023px',
      id: '150'
    },
    {
      name: 'blue face sick',
      position: '-514px -1023px',
      id: '151'
    },
    {
      name: 'blue surprised face',
      position: '-599px -1023px',
      id: '152'
    },
    {
      name: 'furious red face',
      position: '-684px -1023px',
      id: '153'
    },
    {
      name: 'angry red face',
      position: '-769px -1023px',
      id: '154'
    },
    {
      name: 'angry red face',
      position: '-854px -1023px',
      id: '155'
    },
    {
      name: 'laugh',
      position: '-939px -1023px',
      id: '156'
    },
    {
      name: 'smile',
      position: '-4px -1108px',
      id: '157'
    },
    {
      name: 'big smile',
      position: '-89px -1108px',
      id: '158'
    },
    {
      name: 'blushing smile',
      position: '-174px -1108px',
      id: '159'
    },
    {
      name: 'wink',
      position: '-259px -1108px',
      id: '160'
    },
    {
      name: 'heart eyes',
      position: '-344px -1108px',
      id: '161'
    },
    {
      name: 'kiss',
      position: '-429px -1108px',
      id: '162'
    },
    {
      name: 'kiss',
      position: '-514px -1108px',
      id: '163'
    },
    {
      name: 'big eyes',
      position: '-599px -1108px',
      id: '164'
    },
    {
      name: 'closed eyes smile',
      position: '-684px -1108px',
      id: '165'
    },
    {
      name: 'big grin',
      position: '-769px -1108px',
      id: '166'
    },
    {
      name: 'wink with tongue out',
      position: '-854px -1108px',
      id: '167'
    },
    {
      name: 'tongue out',
      position: '-939px -1108px',
      id: '168'
    },
    {
      name: 'looking away',
      position: '-4px -1193px',
      id: '169'
    },
    {
      name: 'smirk',
      position: '-89px -1193px',
      id: '170'
    },
    {
      name: 'sweat',
      position: '-174px -1193px',
      id: '171'
    },
    {
      name: 'looking down',
      position: '-259px -1193px',
      id: '172'
    },
    {
      name: 'frown',
      position: '-344px -1193px',
      id: '173'
    },
    {
      name: 'unpleasant face',
      position: '-429px -1193px',
      id: '174'
    },
    {
      name: 'sweat',
      position: '-514px -1193px',
      id: '175'
    },
    {
      name: 'pale sweat',
      position: '-599px -1193px',
      id: '176'
    },
    {
      name: 'pale',
      position: '-684px -1193px',
      id: '177'
    },
    {
      name: 'distressed',
      position: '-769px -1193px',
      id: '178'
    },
    {
      name: 'tears',
      position: '-854px -1193px',
      id: '179'
    },
    {
      name: 'crying',
      position: '-939px -1193px',
      id: '180'
    },
    {
      name: 'tears of laughter',
      position: '-4px -1278px',
      id: '181'
    },
    {
      name: 'crossed-out eyes',
      position: '-89px -1278px',
      id: '182'
    },
    {
      name: 'horrified face',
      position: '-174px -1278px',
      id: '183'
    },
    {
      name: 'angry frown',
      position: '-259px -1278px',
      id: '184'
    },
    {
      name: 'scary angry face',
      position: '-344px -1278px',
      id: '185'
    },
    {
      name: 'sleeping face',
      position: '-429px -1278px',
      id: '186'
    },
    {
      name: 'sick',
      position: '-514px -1278px',
      id: '187'
    },
    {
      name: 'stone face',
      position: '-599px -1278px',
      id: '188'
    },
    {
      name: 'cat face',
      position: '-684px -1278px',
      id: '189'
    },
    {
      name: 'eating face',
      position: '-769px -1278px',
      id: '190'
    },
    {
      name: 'baby',
      position: '-854px -1278px',
      id: '191'
    },
    {
      name: 'girl',
      position: '-939px -1278px',
      id: '192'
    },
    {
      name: 'boy',
      position: '-4px -1363px',
      id: '193'
    },
    {
      name: 'man',
      position: '-89px -1363px',
      id: '194'
    },
    {
      name: 'woman',
      position: '-174px -1363px',
      id: '195'
    },
    {
      name: 'elderly man',
      position: '-259px -1363px',
      id: '196'
    },
    {
      name: 'elderly woman',
      position: '-344px -1363px',
      id: '197'
    },
    {
      name: 'blonde woman',
      position: '-429px -1363px',
      id: '198'
    },
    {
      name: 'blonde man',
      position: '-514px -1363px',
      id: '199'
    },
    {
      name: 'man with brown hair',
      position: '-599px -1363px',
      id: '200'
    },
    {
      name: 'woman with brown hair',
      position: '-684px -1363px',
      id: '201'
    },
    {
      name: 'woman',
      position: '-769px -1363px',
      id: '202'
    },
    {
      name: 'man',
      position: '-854px -1363px',
      id: '203'
    },
    {
      name: 'man with glasses',
      position: '-939px -1363px',
      id: '204'
    },
    {
      name: 'man with turban',
      position: '-4px -1448px',
      id: '205'
    },
    {
      name: 'woman with headscarf',
      position: '-89px -1448px',
      id: '206'
    },
    {
      name: 'young woman',
      position: '-174px -1448px',
      id: '207'
    },
    {
      name: 'young man',
      position: '-259px -1448px',
      id: '208'
    },
    {
      name: 'teenager',
      position: '-344px -1448px',
      id: '209'
    },
    {
      name: 'police officer',
      position: '-429px -1448px',
      id: '210'
    },
    {
      name: 'santa claus',
      position: '-514px -1448px',
      id: '211'
    },
    {
      name: 'demon',
      position: '-599px -1448px',
      id: '212'
    },
    {
      name: 'alien in ufo',
      position: '-684px -1448px',
      id: '213'
    },
    {
      name: 'alien',
      position: '-769px -1448px',
      id: '214'
    },
    {
      name: 'heart',
      position: '-854px -1448px',
      id: '215'
    },
    {
      name: 'broken heart',
      position: '-939px -1448px',
      id: '216'
    },
    {
      name: 'heart',
      position: '-4px -1533px',
      id: '217'
    },
    {
      name: 'three hearts',
      position: '-89px -1533px',
      id: '218'
    },
    {
      name: 'two hearts',
      position: '-174px -1533px',
      id: '219'
    },
    {
      name: 'heart with blue ribbon',
      position: '-259px -1533px',
      id: '220'
    },
    {
      name: 'hearts',
      position: '-344px -1533px',
      id: '221'
    },
    {
      name: 'white heart',
      position: '-429px -1533px',
      id: '222'
    },
    {
      name: 'crystal heart',
      position: '-514px -1533px',
      id: '223'
    },
    {
      name: 'two hearts',
      position: '-599px -1533px',
      id: '224'
    },
    {
      name: 'sparkling heart',
      position: '-684px -1533px',
      id: '225'
    },
    {
      name: 'heart with border',
      position: '-769px -1533px',
      id: '226'
    },
    {
      name: 'arrow through heart',
      position: '-854px -1533px',
      id: '227'
    },
    {
      name: 'kissing lips',
      position: '-939px -1533px',
      id: '228'
    },
    {
      name: 'waving hand',
      position: '-4px -1618px',
      id: '229'
    },
    {
      name: 'open hands',
      position: '-89px -1618px',
      id: '230'
    },
    {
      name: 'ok sign',
      position: '-174px -1618px',
      id: '231'
    },
    {
      name: 'fist',
      position: '-259px -1618px',
      id: '232'
    },
    {
      name: 'clapping hands',
      position: '-344px -1618px',
      id: '233'
    },
    {
      name: 'thumbs down',
      position: '-429px -1618px',
      id: '234'
    },
    {
      name: 'pointing left',
      position: '-514px -1618px',
      id: '235'
    },
    {
      name: 'pointing right',
      position: '-599px -1618px',
      id: '236'
    },
    {
      name: 'peace sign',
      position: '-684px -1618px',
      id: '237'
    },
    {
      name: 'open hand',
      position: '-769px -1618px',
      id: '238'
    },
    {
      name: 'fist',
      position: '-854px -1618px',
      id: '239'
    },
    {
      name: 'thumbs up',
      position: '-939px -1618px',
      id: '240'
    },
    {
      name: 'one finger',
      position: '-4px -1703px',
      id: '241'
    },
    {
      name: 'pointing up',
      position: '-89px -1703px',
      id: '242'
    },
    {
      name: 'pointing down',
      position: '-174px -1703px',
      id: '243'
    },
    {
      name: 'strong arm',
      position: '-259px -1703px',
      id: '244'
    },
    {
      name: 'nose',
      position: '-344px -1703px',
      id: '245'
    },
    {
      name: 'ear',
      position: '-429px -1703px',
      id: '246'
    },
    {
      name: 'lips',
      position: '-514px -1703px',
      id: '247'
    },
    {
      name: 'mouth',
      position: '-599px -1703px',
      id: '248'
    },
    {
      name: 'tongue',
      position: '-684px -1703px',
      id: '249'
    },
    {
      name: 'footprints',
      position: '-769px -1703px',
      id: '250'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/operation/fragments/chat_area/line_emoji.js